import { Product } from "../../types/server";

export { products_selector, product_by_id_selector };

function products_selector(state) {
  return state.products;
}
function product_by_id_selector(product_id) {
  return function product_selctor(state): Product | undefined {
    return state.products[product_id];
  };
}
